import { z } from "zod";

export const CallReviewTranscriptWordSchema = z.object({
  word: z.string(),
  start: z.number(),
  end: z.number(),
});

export const CallReviewTranscriptEntrySchema = z.object({
  role: z.string(),
  content: z.string(),
  timestamp: z.number().optional(),
  words: z.array(CallReviewTranscriptWordSchema).optional(),
});

export const CallReviewCollectedAnswerSchema = z.object({
  id: z.string().uuid(),
  questionId: z.string().nullable(),
  questionLabel: z.string(),
  value: z.unknown(),
  valueType: z.string(),
  confidenceScore: z.number().nullable().optional(),
  transcriptSegment: z.string().nullable().optional(),
  createdAt: z.string(),
});

export const CallReviewAlertSchema = z.object({
  id: z.string(),
  name: z.string(),
  severity: z.string(),
  message: z.string(),
  acknowledged: z.boolean(),
  resolved: z.boolean(),
  triggeredAt: z.string(),
});

export const CallReviewSchema = z.object({
  attemptId: z.string().uuid(),
  sessionId: z.string().uuid(),
  followUpId: z.string().uuid().nullable().optional(),
  phaseId: z.string().uuid().nullable().optional(),
  status: z.string(),
  outcome: z.string().nullable().optional(),
  startedAt: z.string().nullable().optional(),
  endedAt: z.string().nullable().optional(),
  durationSeconds: z.number().nullable().optional(),
  disconnectionReason: z.string().nullable().optional(),
  callAgentId: z.string().nullable().optional(),
  callAnalysisSummary: z.string().nullable().optional(),
  userSentiment: z.string().nullable().optional(),
  callSuccessful: z.boolean().nullable().optional(),
  simulated: z.boolean().default(false),
  recordingUrl: z.string().nullable().optional(),
  transcript: z.string().nullable().optional(),
  transcriptObject: z.array(CallReviewTranscriptEntrySchema).nullable().optional(),
  collectedData: z.record(z.string(), z.unknown()),
  collectedAnswers: z.array(CallReviewCollectedAnswerSchema),
  alerts: z.array(CallReviewAlertSchema),
  rawRetellAvailable: z.boolean(),
  rawRetellFetchedAt: z.string().nullable().optional(),
});

export type CallReview = z.infer<typeof CallReviewSchema>;
export type CallReviewTranscriptEntry = z.infer<typeof CallReviewTranscriptEntrySchema>;
export type CallReviewCollectedAnswer = z.infer<typeof CallReviewCollectedAnswerSchema>;
